import { Component, EventEmitter, OnInit, Output } from '@angular/core';
import { CdkDragDrop, moveItemInArray } from '@angular/cdk/drag-drop';
import { ApiService } from 'src/app/api.service';
import { ThemingService } from 'src/app/theming.service';
import { LambdaService } from 'src/app/lambda.service';
declare let $: any;

interface MenuOption {
  menuOptionId: number;
  menuOptionName: string;
  menuOptionUrl: string;
  categoryId: number;
  subCategoryId: number;
  subSubCategoryId: number;
  collectionId: number;
  pageId?: number; // Optional, if not used in your context
  menuOptionType: number;
  menuOptionPosition: number;
  parentOptionId: number | null;
  children?: MenuOption[];
}

interface Menu {
  menuId: number;
  shopId: number;
  menuName: string;
  menuStatus: number;
  options: MenuOption[];
}

@Component({
  selector: 'app-menu',
  templateUrl: './menu.component.html',
  styleUrls: ['./menu.component.scss']
})
export class MenuComponent implements OnInit {
  @Output() editMenuEvent = new EventEmitter<number>();
  menus: Menu[] = [];
  isCreatingMenu = false
  isListingMenu = true;
  isEditingMenu = false;
  loading = false;
  modalDelete = false;
  menuIdToDelete: any;
  editMenuId!: number;
  constructor(
    private apiService: ApiService,
    public themingService: ThemingService,
    private lambdaService: LambdaService // Ensure lambdaService is provided in the module or use @Inject if necessary
  ) { }

  ngOnInit(): void {
    this.getMenu();
  }

  cancelCreation() {
    this.isCreatingMenu= false;
    this.isListingMenu= true;
    this.getMenu();
  }

  cancelEdition(): void {
    this.isEditingMenu= false;
    this.isListingMenu= true;
    this.getMenu();
  }

  editMenu(menuId: number): void {
    this.isEditingMenu = true;
    this.isCreatingMenu = false;
    this.isListingMenu = false;
    this.editMenuId = menuId;
  }

  toggleMenuVisibility(creating: boolean) {
    this.isCreatingMenu = creating;
    this.isListingMenu = !creating;
    if (!creating) {
      this.getMenu();
    }
  }

  /** Convierte el array plano que viene de la API
 *  en una estructura jerárquica  raíces → hijos  */
private buildMenuHierarchy(rows: any[]): Menu[] {

  const menuMap = new Map<number, Menu>();
  const childBucket: Record<number, MenuOption[]> = {};

  rows.forEach(r => {

    /* crea el menú si no existe */
    if (!menuMap.has(r.menuId)) {
      menuMap.set(r.menuId, {
        menuId:     r.menuId,
        shopId:     r.shopId,
        menuName:   r.menuName,
        menuStatus: r.menuStatus,
        options:    []
      });
    }

    const opt: MenuOption = {
      menuOptionId:       r.menuOptionId,
      menuOptionName:     r.menuOptionName,
      menuOptionUrl:      r.menuOptionUrl,
      categoryId:         r.categoryId,
      subCategoryId:      r.subCategoryId,
      subSubCategoryId:   r.subSubCategoryId,
      collectionId:       r.collectionId,
      pageId:             r.pageId,
      menuOptionType:     r.menuOptionType,
      menuOptionPosition: r.menuOptionPosition,
      parentOptionId:     r.parentOptionId
    };

    if (opt.parentOptionId === null) {
      /* raíz */
      menuMap.get(r.menuId)!.options.push(opt);
    } else {
      /* hijo: lo aparcamos; luego lo colgamos del padre real */
      (childBucket[opt.parentOptionId] ||= []).push(opt);
    }
  });

  /* enganchar hijos a su padre */
  menuMap.forEach(menu => {
    menu.options.forEach(root => {
      root.children = (childBucket[root.menuOptionId] || [])
                        .sort((a,b) => a.menuOptionPosition - b.menuOptionPosition);
    });
    menu.options.sort((a,b)=>a.menuOptionPosition-b.menuOptionPosition);
  });

  return Array.from(menuMap.values());
}


getMenu() {
  this.loading = true;

  this.lambdaService.getMenu(this.themingService.shopId)
    .then((response: any) => {

      const rows = Array.isArray(response.menu) ? response.menu : [];

      /* ⬇️  AQUÍ el cambio: */
      this.menus = this.buildMenuHierarchy(rows);

    })
    .catch(err => console.error('Error fetching menu:', err))
    .finally(() => this.loading = false);
}


  getMenuOptionValue(option: MenuOption): string {
    if (option.categoryId > 0) {
      return option.categoryId.toString();
    } else if (option.subCategoryId > 0) {
      return option.subCategoryId.toString();
    } else if (option.subSubCategoryId > 0) {
      return option.subSubCategoryId.toString();
    } else if (option.collectionId > 0) {
      return option.collectionId.toString();
    } else {
      return '';
    }
  }
  
  drop(event: CdkDragDrop<MenuOption[]>, menuItem: Menu) {
    moveItemInArray(menuItem.options, event.previousIndex, event.currentIndex);
    menuItem.options.forEach((option, index) => {
      option.menuOptionPosition = index + 1;
    });

    const positions = menuItem.options.reduce((acc, option) => {
      acc[option.menuOptionId] = option.menuOptionPosition;
      return acc;
    }, {} as { [key: number]: number });

    const updateData = {
      shopId: this.themingService.shopId,
      menuId: menuItem.menuId,
      positions: positions
    };
    this.updateMenuOptionsPositions(updateData);
  }

  toggleMenuStatus(menuItem: Menu) {
    if (menuItem.menuStatus === 1) {
      menuItem.menuStatus = 0;
    } else {
      this.menus.forEach(item => {
        item.menuStatus = 0;
      });
      menuItem.menuStatus = 1;
    }
    this.updateMenuStatus(menuItem.menuId, menuItem.menuStatus);
  }
  

  updateMenuStatus(menuId: number, status: number) {
    this.lambdaService.updateMenuStatus(status, menuId, this.themingService.shopId)
      .then(response => console.log('Status updated:', response))
      .catch(error => console.error('Error updating status:', error));
  }

  updateMenuOptionsPositions(updateData: { shopId: number, menuId: number, positions: { [key: number]: number } }) {
    this.lambdaService.updateMenuOptionsPositions(updateData)
      .then(response => console.log('Menu options positions updated:', response))
      .catch(error => console.error('Error updating menu options positions:', error));
  }

  deleteMenu(response: number){
    if(response){
      this.loading = true; 
      this.lambdaService.deleteMenu(this.themingService.shopId, this.menuIdToDelete)
      .then((data)=>{
        console.log("data: ", JSON.stringify(data));
        this.getMenu();
        $('#deleteMenuModal').modal('show');
        this.loading = false;
      })
      this.modalDelete = false;
    }else {
      this.modalDelete = false;
    }
  }

  confirmDelete(menuId: number) {
    this.menuIdToDelete = menuId;
    this.modalDelete = true;
 }


  closeModal(){
    $('#deleteMenuModal').modal('hide');
  }
}